import { useCallback } from 'react';
import { ISignal, useCustomFetch } from "../custom-fetch";
import { IHeaderLink } from '../shared/IHeaderLink';

export const useHeaderLinksService = () => {
  const customFetch = useCustomFetch();

  const fetchHeaderLinks = useCallback(async ({ signal }: ISignal) => {
    const [links] = await customFetch<IHeaderLink[]>("/json/headerlinks", { signal });
    return links;
  }, [customFetch]);

  const saveHeaderLink = useCallback(async (data: IHeaderLink) => {
    const [link] = await customFetch<IHeaderLink>("/json/headerlinks/add", {
      method: "POST",
      body: JSON.stringify(data),
    });
    return link;
  }, [customFetch]);

  const saveHeaderLinks = useCallback(async (links: IHeaderLink[]) => {
    const [savedLinks] = await customFetch<IHeaderLink[]>("/json/headerlinks/add", {
      method: "POST",
      body: JSON.stringify({ links }),
    });
    return savedLinks;
  }, [customFetch]);

  const deleteHeaderLink = useCallback(async (id: string) => {
    await customFetch<void>("/json/headerlinks/delete", {
      method: "POST",
      body: JSON.stringify({ id }),
    });
    return true;
  }, [customFetch]);

  return { fetchHeaderLinks, saveHeaderLink, saveHeaderLinks, deleteHeaderLink };
}
